import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-page',
  template: '<router-outlet></router-outlet>'
})
export class PublicPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
